'use client';

import { memo } from 'react';

import { useTranslations } from 'next-intl';

import PoolsTokenInfo from '@/app/[locale]/(main)/(home)/_components/Pools/PoolsTokenInfo';
import PresaleEnded from '@/app/[locale]/(main)/(home)/_components/Pools/TokenInfoEnded/PresaleEnded';
import { cn } from '@/lib/utils/cn';
import { T_Pool } from '@/ts/types/T_Pool';

import { TokenHeader } from '../TokenHeader';

interface I_TokenInfoEndedProps {
  token: T_Pool;
  className?: string;
  isModal?: boolean;
  closeModal?: () => void;
}

export const TokenInfoEnded = memo(
  ({ token, className = '', isModal, closeModal }: I_TokenInfoEndedProps) => {
    const t = useTranslations('pools');

    const bannerUrl = token.banner?.url || token.bannerMobile?.url || '';
    const bannerAlt =
      token.banner?.alt || token.bannerMobile?.alt || token.tokenName;
    const currentPrice = parseFloat(token?.presaleTokenPriceInUSDC) || 0;

    return (
      <div className={cn('bg-background', className)}>
        <TokenHeader
          bannerUrl={bannerUrl}
          bannerAlt={bannerAlt}
          tokenSymbol={token.tokenSymbol}
          currentPrice={currentPrice}
          color={token.color}
          t={t}
          pool={token}
        />

        <PresaleEnded />
        <PoolsTokenInfo
          token={token}
          closeModal={closeModal}
          isModal={isModal}
        />
      </div>
    );
  }
);

TokenInfoEnded.displayName = 'TokenInfoEnded';
